import { useState, useEffect, ReactNode } from "react";
import ThemeContext, { initialThemeState } from "./ThemeContext";
import { ConfigProvider, theme as antTheme } from "antd";
import { getLocalStorageValue, setLocalStorageValue } from "@xompass/web-sdk";

type props = {
  children: ReactNode;
};

const ThemeProvider = ({ children }: props) => {
  const params = new URLSearchParams(window.location.search);
  const themeParam = params.get("theme");
  const storedTheme = getLocalStorageValue("globalTheme");
  const initialTheme =
    themeParam === "light" || themeParam === "dark"
      ? themeParam
      : storedTheme === "light" || storedTheme === "dark"
        ? storedTheme
        : initialThemeState.theme;

  const [theme, setTheme] = useState<string>(initialTheme);
  const handleThemeChange = () => {
    if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  };

  useEffect(() => {
    setLocalStorageValue("globalTheme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, handleThemeChange }}>
      <ConfigProvider
        theme={{
          cssVar: {
            key: "forensic-reconstruction-ui",
          },
          token: {
            colorPrimary: "#707edc",
            colorInfo: "#707edc",
            colorSuccess: "#00a86b",
            colorWarning: "#f0ad4e",
            fontSize: 14,
            wireframe: false,
          },
          components: {
            Slider: {
              trackBg: "#707EDC",
              trackHoverBg: "#8697E5",
              handleColor: "#8697E5",
              handleActiveColor: "#C8DCFE",
              dotActiveBorderColor: "#8697E5",
            },
          },
          algorithm:
            theme === "dark"
              ? antTheme.darkAlgorithm
              : antTheme.defaultAlgorithm,
        }}
      >
        <div
          className={`theme--${theme}`}
          style={{ height: "100%", overflow: "auto" }}
        >
          <div id="main">{children}</div>
        </div>
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
